<template>
    <section>
        <div class="container container--fluid">
            <v-card>
                <v-card-title class="headline">
                    {{$t('fax_numbers_title')}}
                    <v-spacer></v-spacer>
                    <v-btn
                            small
                            color="primary"
                            class="white--text"
                            @click="showForm()"
                    >
                        {{$t('create')}}
                        <v-icon right dark>mdi-plus</v-icon>
                    </v-btn>
                    <v-btn
                            icon
                            small
                            @click="fetch()"
                    >
                        <v-icon right dark>mdi-reload</v-icon>
                    </v-btn>
                </v-card-title>
                <v-data-table
                        class="text-capitalize"
                        :headers="headers"
                        :items="items"
                        :loading="loading"
                        :options.sync="options"
                        :server-items-length="total"
                        :page="options.page"
                        :items-per-page="options.itemsPerPage"
                        :footer-props="footerProps"
                >
                    <template v-slot:top>
                        <div class="d-flex justify-start mb-6">
                            <v-text-field
                                    append-icon="mdi-magnify"
                                    v-model="search"
                                    :loading="!!searchHandler"
                                    label="شماره فکس"
                                    class="mx-4 pa-1"
                            ></v-text-field>
                            <v-select
                                    clearable
                                    v-model="filters.state.value"
                                    :label="$t('fax_number_state')"
                                    :items="stateOptions"
                                    item-text="value"
                                    item-value="key"
                                    class="mx-4 pa-1"
                            ></v-select>
                            <v-select
                                    clearable
                                    v-model="filters.zone.value"
                                    :label="$t('zone')"
                                    :items="zoneOptions"
                                    item-text="value"
                                    autocomplete="off"
                                    item-value="key"
                                    class="mx-4 pa-1"
                            ></v-select>
                            <v-autocomplete
                                    clearable
                                    v-model="filters.fax_channel_id.value"
                                    :items="faxChannelItems"
                                    autocomplete="off"
                                    item-text="name"
                                    item-value="id"
                                    :loading="fetchingFaxChannels"
                                    :label="$t('fax_channel')"
                                    class="mx-4 pa-1"
                            ></v-autocomplete>

                            <v-autocomplete
                                    clearable
                                    v-model="filters.user_id.value"
                                    :items="usersItems"
                                    autocomplete="off"
                                    item-text="full_name"
                                    item-value="id"
                                    :loading="fetchingUsers"
                                    :label="$t('user')"
                                    class="mx-4 pa-1"
                            ></v-autocomplete>
                        </div>

                    </template>
                    <template #item.number="{item}">
                        <v-tooltip
                                top
                                content-class="caption iransans"
                                transition="slide-y-reverse-transition"
                        >
                            <template #activator="{ on }">
                                <v-icon
                                        v-on="on"
                                        :color="item.incoming ? 'success' : 'green lighten-5'"
                                        small
                                        class="ml-2"
                                >mdi-arrow-down-thick</v-icon>
                            </template>
                            <span>{{$t('incoming')}}</span>
                        </v-tooltip>

                        <v-tooltip
                                top
                                content-class="caption iransans"
                                transition="slide-y-reverse-transition"
                        >
                            <template #activator="{ on }">
                                <v-icon
                                        v-on="on"
                                        :color="item.outgoing ? 'success' : 'green lighten-5'"
                                        small
                                        class="ml-2"
                                >mdi-arrow-up-thick</v-icon>
                            </template>

                            <span>{{$t('outgoing')}}</span>
                        </v-tooltip>
                        {{item.number}}
                        <v-chip
                                v-if="item.vertical_service_code"
                                color="info"
                                small
                                class="ma-2"
                                text-color="white"
                        >
                            {{$t('to_vertical_service_code' , {
                            to_vertical_service_code : item.vertical_service_code
                            })}}
                        </v-chip>
                    </template>
                    <template #item.fax_channel_id="{item}">
                        <transition name="fade" mode="out-in">
                            <v-chip
                                    v-if="!item.fax_channel_id"
                                    color="error"
                                    x-small
                            > -- </v-chip>

                            <v-skeleton-loader
                                    v-else-if="fetchingFaxChannels"
                                    type="text"
                                    class="mt-2"
                            ></v-skeleton-loader>

                            <div v-else>
                                <v-tooltip top color="info" v-if="faxChannels[item.fax_channel_id].description">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                                v-bind="attrs" v-on="on"
                                                color="info"
                                        >mdi-information-outline</v-icon>
                                    </template>
                                    <span>{{faxChannels[item.fax_channel_id].description}}</span>
                                </v-tooltip>
                                {{ faxChannels[item.fax_channel_id].name }}
                            </div>
                        </transition>
                    </template>
                    <template #item.user_id="{item}">
                        <span>
                            {{ item.user_fullname}} {{item.user_mobile}}
                        </span>
                    </template>
                    <template #item.zone="{item}">
                        {{ $t('zone_options')[item.zone] }}
                    </template>
                    <template #item.setup_fee="{item}">
                        <v-icon v-if="item.grade == 'gold'">mdi-shield-star</v-icon>
                        <v-icon v-else-if="item.grade == 'silver'">mdi-star</v-icon>
                        <v-icon v-else>mdi-star-four-points-outline</v-icon>

                        <span v-if="item.setup_fee">
                            {{$t('display_price', { price : $n(item.setup_fee) })}}
                        </span>
                        <v-chip
                                v-else
                                color="success"
                                small
                        >{{$t('free')}}</v-chip>
                    </template>
                    <template #item.state="{item}">
                        {{ $t('fax_number_state_options')[item.state] }}
                    </template>
                    <template #item.created_at="{item}">
                        {{ getJalaliDate(item.created_at * 1000) }}
                    </template>
                    <template #item.actions="{item}">
                        <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon small @click="showForm(item)" v-bind="attrs" v-on="on">
                                    <v-icon>mdi-pencil</v-icon>
                                </v-btn>
                            </template>
                            <span>{{$t('edit')}}</span>
                        </v-tooltip>
                        <v-tooltip top v-if="userCan('receipts')">
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn icon small @click="deleteItem(item)" v-bind="attrs" v-on="on"  :loading="deletingIds.indexOf(item.id) > -1" >
                                    <v-icon>mdi-delete</v-icon>
                                </v-btn>
                            </template>
                            <span>{{$t('delete')}}</span>
                        </v-tooltip>
                    </template>
                </v-data-table>
            </v-card>
            <Form
                    v-if="item"
                    :item="item"
                    @close="item = null"
                    @submit="fetch"
            ></Form>
        </div>
    </section>
</template>

<script>
    import { mapState,mapActions, mapGetters } from 'vuex';

    import RequestList from "../services/RequestList";
    import Service from "../services/FaxNumbersService";
    import Form from "../components/FaxNumberForm";
    import CRUDMixin from '../mixins/CRUDMixin'

    export default {
        mixins : [CRUDMixin],

        components : {
            Form
        },
        computed: {
            ...mapGetters({
                faxChannels: 'faxChannels/keyedById',
                fetchingFaxChannels: 'faxChannels/fetching',
            }),
            ...mapState({
                faxChannelItems: state => state.faxChannels.items
            }),
            stateOptions(){
                return Object.keys(this.$t("fax_number_state_options")).map(key => {
                    return {
                        key,
                        value: this.$t("fax_number_state_options")[key]
                    }
                });
            },
            zoneOptions(){
                return Object.keys(this.$t("zone_options")).map(key => {
                    return {
                        key,
                        value: this.$t("zone_options")[key]
                    }
                });
            }
        },
        watch: {
            search(str){
                if( this.searchHandler ){
                    clearTimeout(this.searchHandler);
                }
                if(!str && this.filters.number.value){
                    this.filters.number.value = null;
                }

                if( str.length <= 3 ){
                    return '';
                }
                this.searchHandler = setTimeout( () => {
                    this.filters.number.value = str;
                    this.searchHandler = null;
                }, 1000);
            },
            dialog (val) {
                !val && this.close()
            },
            
            filters: {
                handler(filters) {
                    let filtersQuery = [];


                    Object.values(filters).map( filter => {
                        if(filter.value){
                            filtersQuery.push({...filter});
                        }
                    });

                    this.$router.push({
                        query : {
                            filters : filtersQuery,
                            page : 1,
                            count : this.options.itemsPerPage
                        }
                    }).catch(err => err);
                },
                deep: true,
            },
        },
        data() {
            return {
                searchHandler : null,
                item : null,
                loading : false,
                deletingIds : [],
                headers : [
                    {
                        text: this.$t('id'),
                        value: 'id',
                    },
                    {
                        text: this.$t('fax_number'),
                        value: 'number',
                    },
                    {
                        text: this.$t('zone'),
                        value: 'zone',
                    },
                    {
                        text: this.$t('setup_fee'),
                        value: 'setup_fee',
                    },
                    {
                        text: this.$t('user'),
                        value: 'user_id',
                    },
                    {
                        text: this.$t('fax_channel'),
                        value: 'fax_channel_id',
                    },
                    {
                        text: this.$t('fax_number_state'),
                        value: 'state',
                    },
                    {
                        text: this.$t('created_at'),
                        value: 'created_at',
                    },
                    {
                        text: this.$t('action'),
                        value: 'actions',
                    }
                ],
                filters : {
                    number : {
                        column_name : 'number',
                        operand : 'Contains',
                        value : undefined
                    },
                    state : {
                        column_name : 'state',
                        operand : 'IsEqualTo',
                        value : undefined
                    },
                    zone : {
                        column_name : 'zone',
                        operand : 'IsEqualTo',
                        value : undefined
                    },
                    fax_channel_id : {
                        column_name : 'fax_channel_id',
                        operand : 'IsEqualTo',
                        value : undefined
                    },
                    user_id : {
                        column_name : 'user_id',
                        operand : 'IsEqualTo',
                        value : undefined
                    },
                },
                items : [],
                search : null
            }
        },
        mounted() {
            if(Object.keys(this.faxChannels).length <= 0){
                this.syncFaxChannels();
            }
        },
        methods: {
            ...mapActions({
                syncFaxChannels: 'faxChannels/sync'
            }),

            async fetch() {
                this.loading = true;
                
                let page = this.$route.query.page || 1;
                let count = this.$route.query.count || this.options.itemsPerPage;

                let requestList = new RequestList();

                requestList.setFilters(this.$route.query.filters || []);
                requestList.addOrder('id','desc');
                requestList.setPage(page, count);

                try {
                    let {data} = await Service.list(requestList);
                    this.items = data.value.fax_numbers;
                    this.total = data.value.total;
                } finally {
                    this.loading = false;
                }
            },
            async deleteItem(item){
                if(!
                        confirm( this.$t('faxNumberDeleteQuestion'))
                ){
                    return false;
                }
                this.deletingIds.push(item.id);

                    try {
                        let {
                            data
                        } = await Service.delete(item.id);

                        this.$notify({
                            group: 'formGroup',
                            type: 'success',
                            title: data.message,
                        });

                        this.fetch();
                        this.deletingIds.splice(this.deletingIds.indexOf(item.id), 1);

                    } finally {
                        this.loading = false;
                    }
            },
            showForm(item) {
                item = item || Service.getDefault();
                this.item = item;
            }

        }
    }
</script>